import {LocationDataInterface} from "../interfaces/LocationDataInterface";
import {FieldOptions} from "../constants/constants";

const mapping = {
    'address': FieldOptions.ADDRESS,
    'number': FieldOptions.NR,
    'numberLetter': FieldOptions.ADDRESS_LETTER,
    'addition': FieldOptions.ADDRESS_ADDITION,
    'postalCode': FieldOptions.POSTAL_CODE,
    'city': FieldOptions.CITY
}

export const mapLocationKeysToFilterData = (LocationData: LocationDataInterface) => {

    const filterFields = [] as string[]
    const filterValues = [] as string[]

    const filteredLocationKeys = Object.keys(LocationData).filter((key) => {
        const value = LocationData[key]
        return value !== null && value !== ''
    })

    filteredLocationKeys.forEach((key) => {
        if (mapping[key]) {
            filterFields.push(mapping[key])
            filterValues.push(LocationData[key])
        }
    })

    return {
        filterFields: filterFields,
        filterValues: filterValues
    }
}